export const Footer = () => {
    return (
        <footer className="bg-blue-500 text-center text-white p-3 w-full">
            Salvando Lomitos y Michis - 2023
        </footer>
    )
}
